import Vue from 'vue'
export const guideState = Vue.observable({ library: false, manager: false, running: false, requested: null, picking: false, pickerMode: 'navigate', pickerLabels: {}, picked: null, pickerNotice: '' })
// In-memory only: the persistent root host takes over when the source page unmounts.
export const guideEditorState = Vue.observable({ draft: null, selected: 0, rowNumber: 1 })
export function beginGuidePicker() {
  guideState.picked = null
  guideState.pickerNotice = ''
  guideState.pickerMode = 'navigate'
  guideState.manager = true
  guideState.picking = true
}
export function endGuidePicker(picked = null) {
  if (picked) guideState.picked = picked
  guideState.picking = false
  guideState.pickerMode = 'navigate'
}
export function resetGuideEditor() {
  endGuidePicker()
  guideState.manager = false
  guideState.picked = null
  guideState.pickerNotice = ''
  guideState.pickerLabels = {}
  guideEditorState.draft = null
  guideEditorState.selected = 0
  guideEditorState.rowNumber = 1
}
export function openGuideLibrary() { guideState.library = true }
export function launchGuide(guide) { guideState.requested = { guide, request: Date.now() }; guideState.library = false }
